import React, { useState, useEffect } from 'react'
import ChatMessage from './ChatMessage'
import ChatInput from './ChatInput'
import LoadingDefault from '../Elements/Loading/LoadingDefault'
import ChatSettingsModal from './ChatSettingsModal'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCogs } from '@fortawesome/pro-duotone-svg-icons/faCogs'
import { Alert } from '@mui/material'

const ChatWindow = ({
    messages,
    isLoading,
    inputValue,
    onInputChange,
    onSend,
    messagesEndRef,
    kedo,
    links,
    chatData,
    selections,
    setSelections,
}) => {
    const [showSettings, setShowSettings] = useState(false)

    return (
        <div className="chat-window">
            <div className="chat-header">{kedo.t('chat.title')}</div>

            <div className="chat-body">
                {chatData?.dossier ? (
                    <Alert severity={'info'}>
                        💬 You can ask questions about{' '}
                        {chatData?.defdossier?.name}{' '}
                        <strong>{chatData?.dossier?.summary || 'item'}</strong>.
                        Your data stays private, but please note that BitBean
                        may occasionally make mistakes. <br />
                        <button
                            className="settings-button"
                            onClick={() => setShowSettings(true)}
                        >
                            <FontAwesomeIcon icon={faCogs} /> Click here to add
                            links for BitBean(makes him understand the{' '}
                            {chatData?.defdossier?.name} better)
                        </button>
                    </Alert>
                ) : null}
                {messages.map((msg) => (
                    <ChatMessage key={msg.id} message={msg} kedo={kedo} />
                ))}
                {isLoading && (
                    <div className="chat-loading">
                        <LoadingDefault size="sm" />
                    </div>
                )}
                <div ref={messagesEndRef} />
            </div>

            <ChatInput
                value={inputValue}
                onChange={onInputChange}
                onSend={onSend}
                disabled={isLoading}
                placeholder={kedo.t('chat.inputPlaceholder')}
                sendLabel={kedo.t('chat.send')}
            />
            {showSettings && (
                <ChatSettingsModal
                    chatData={chatData}
                    setSelections={setSelections}
                    selections={selections}
                    onSave={(newSelections) => setSelections(newSelections)}
                    show={showSettings}
                    links={links}
                    onClose={() => setShowSettings(false)}
                    kedo={kedo}
                />
            )}
        </div>
    )
}

export default ChatWindow
